import { AskResponse, getCitationFilePath } from "../../api";

interface propsData {
    answer: AskResponse;
    onCitationClicked: (filePath: string) => void;
}
export const AnswerLinksProcess = ({ answer, onCitationClicked }: propsData) => {
    const getIdLinks = (arrayLinks: string[]) => {
        return arrayLinks.map(element => {
            let idLink = "";
            if (element.includes("_httpst3.telefonica.eselypseplusrendergenericRender.xhtml")) {
                idLink = element.split("_")[0];
            } else {
                const aux = element.split("-");
                aux.pop();
                idLink = aux.join("-");
            }
            return idLink;
        });
    };

    const getTimeInLink = (link: string) => {
        // let linkSplitted: string = link.split("f=")[1].split("-")[0];
        let linkSplitted: string = link.split("f=")[1].split(".")[0];
        const linkDate = new Date();
        linkDate.setFullYear(parseInt(linkSplitted.slice(4, linkSplitted.length)));
        linkDate.setMonth(parseInt(linkSplitted.slice(2, 4)) - 1);
        linkDate.setDate(parseInt(linkSplitted.slice(0, 2)));
        console.log(linkDate);
        return linkDate.getTime();
    };

    const links = answer.links;
    let idLinks: string[] = [""];
    let idLinks_sin_seccion: string[] = [""];
    let linksFiltered: string[] = [""];
    let cont = 0;
    let long = 65;
    if (links != undefined) {
        links.forEach(e => {
            let puntos = "";
            if (long < e.title.length) puntos = "...";

            let reg = "";
            let reg_sin_seccion="";
            reg_sin_seccion =
                e.id +
                " - \"" +
                e.title.toString().substring(0, long) +
                puntos +
                "\" - (" +
                e.vigencia_dates +
                ") - " +
                e.vigente;
            reg = reg_sin_seccion + "|!" +e.sectionid;
                idLinks_sin_seccion
            if (!idLinks_sin_seccion.includes(reg_sin_seccion)) {
                idLinks.push(cont.toString());
                idLinks_sin_seccion.push(reg_sin_seccion);
                linksFiltered.push(reg);
                cont++;
            }
        });
    }

    return { linksFiltered, idLinks };
};
